import { safeMerge } from "../../common/utilities";
export default function (_ref) {
  var _theme$components;

  let {
    theme,
    height,
    disclosureListsHeight,
    leftColumnWidth,
    width,
    header
  } = _ref;
  let cssRoot = {},
      cssInnerContainer = {},
      cssHeader = {},
      cssDisclosureLists = {},
      cssLeftColumn = {},
      cssRightColumn = {},
      cssContentArea = {};
  const disclosurelistcontainer = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.disclosurelistcontainer;

  if (disclosurelistcontainer) {
    cssRoot = disclosurelistcontainer.root;
    cssInnerContainer = safeMerge(disclosurelistcontainer.innerContainer, {
      height,
      width
    });
    cssLeftColumn = safeMerge(disclosurelistcontainer.leftColumn, {
      width: leftColumnWidth,
      minWidth: leftColumnWidth
    });
    cssHeader = header ? disclosurelistcontainer.header : disclosurelistcontainer.emptyHeader;
    cssDisclosureLists = disclosurelistcontainer.disclosureLists;
    cssDisclosureLists = safeMerge(cssDisclosureLists, {
      height: disclosureListsHeight
    });
    cssRightColumn = disclosurelistcontainer.rightColumn;
    cssContentArea = disclosurelistcontainer.contentArea;
  }

  return {
    cssRoot,
    cssInnerContainer,
    cssLeftColumn,
    cssRightColumn,
    cssHeader,
    cssDisclosureLists,
    cssContentArea
  };
}